import Vue from "vue";
import App from "./App.vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
});

//external dependencies
import Toasted from "vue-toasted";
import * as VueGoogleMaps from "vue2-google-maps";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BootstrapVue from "bootstrap-vue";
import InstantSearch from "vue-instantsearch";
import { rtdbPlugin } from "vuefire";
import { firestorePlugin } from "vuefire";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
import "vue-search-select/dist/VueSearchSelect.css";

//modules
import constants from "@/modules/constants";
import router from "@/modules/router";
import store from "@/modules/store";
import { getUser, logout } from "@/modules/auth";
import { getProducts, getVendorProducts } from "@/modules/database";

//populate font awesome icons
import "./modules/faIconLibrary";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

//animation
import SweetAlertIcons from "vue-sweetalert-icons";

Vue.use(SweetAlertIcons);

// use tamplates
import Default from "./layouts/Default.vue";
import Website from "./layouts/Website.vue";
import Admin from "./layouts/Admin.vue";
import UserLogin from "./layouts/UserLogin.vue";

Vue.component("default-layout", Default);
Vue.component("website-layout", Website);
Vue.component("admin-layout", Admin);
Vue.component("user-layout", UserLogin);

//use modules
Vue.use(VueGoogleMaps, {
  load: {
    key: constants.api_keys.googlemaps,
    libraries: "places,drawing,geometry"
  }
});
import ReadMore from "vue-read-more";
Vue.use(ReadMore);
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(Toasted);
Vue.use(BootstrapVue);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(InstantSearch);
Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);

//Progressive Web App support
import "./modules/registerServiceWorker";

// disable production tip in console
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  mounted() {
    getUser();
    getProducts();
    getVendorProducts();
  },

  methods: {
    logout() {
      logout().then(() => {
        // this.$store.dispatch("clearAuth"); ::already done in auth listener
        this.toast(constants.info.logged_out);
        router.push("/");
      });
    },
    toast(text) {
      this.$toasted.show(text, {
        theme: "primary",
        position: "top-center",
        duration: 3000
      });
    }
  },

  created() {
    AOS.init();
  },
  render: h => h(App)
}).$mount("#app");
